export default () => {
  return new Promise((resolve) => {
    resolve({
      'accordion': {
        'hideFeatures': 'Hide features',
        'showFeatures': 'Show features'
      },
      'availableLanguages': 'Available languages',
      'enquireNow': 'enquire now',
      'bonkers_mktg_optin': 'YES, add me to your email list',
      'boolean': {
        'no': 'No',
        'yes': 'Yes'
      },
      'breadcrumbs': {
        'about': 'About',
        'account': 'My Account',
        'ads': 'Ads',
        'apply': 'Apply',
        'articleCategories': {
          'all': 'All',
          'banking': 'Banking',
          'broadband-phone': 'Broadband, Phone, & TV',
          'gas-electricity': 'Gas & Electricity',
          'insurance': 'Insurance',
          'mortgages': 'Mortgages',
          'personal-finance': 'Personal Finance'
        },
        'banking': 'Banking',
        'blog': 'Blog',
        'broadband': 'Broadband, Phone, and TV',
        'call-back': 'Arrange a Callback',
        'cards': 'Credit Cards',
        'careers': 'Careers',
        'competitions': 'Competitions',
        'commissions': 'Commissions',
        'csr': 'Corporate Social Responsibility',
        'accredited-by-cru': 'Accredited by the CRU',
        'current-accounts': 'Current Accounts',
        'declaration': 'Declaration',
        'energy': 'Gas & Electricity',
        'guaranteed-irish': 'Guaranteed Irish',
        'guides': 'Guides',
        'health-insurance': 'Health Insurance',
        'help': 'Help Centre',
        'home': 'Home',
        'home-insurance': 'Home Insurance',
        'home-movers': 'Home Movers',
        'household': 'Household',
        'insurance': 'Insurance',
        'ireland': 'Broadband in Ireland',
        'lenders': 'Personal Loans Lenders',
        'life-insurance': 'Life Insurance',
        'lifetime-loans': 'Lifetime Loans (Equity Release)',
        'loans': 'Personal Loans',
        'media': 'In the media',
        'mortgageCentre': 'Mortgage Centre',
        'mortgages': 'Mortgages',
        'mortgage-lenders': 'Mortgage Lenders',
        'mortgage-protection': 'Mortgage Protection Insurance',
        'newsroom': 'Newsroom',
        'car-insurance': 'Car Insurance',
        'about-you': 'About you',
        'additional-drivers': 'Additional drivers',
        'declarations': 'Declarations',
        'driving-exp': 'Driving experience',
        'your-car': 'Your car',
        'your-home': 'Your home',
        'income-protection': 'Income Protection',
        'orders': 'Orders',
        'provider-questions': 'Optional addons',
        'podcasts': 'Podcasts',
        'prepay-cards': 'Prepaid Cards',
        'price-change-calendar': 'Price change calendar',
        'price-changes': 'Price changes',
        'privacy': 'Privacy Policy',
        'profile': 'Profile',
        'providers': 'Providers',
        'rate-changes': 'Rate Changes',
        'reasons-why': '10 Reasons Why',
        'reviews': 'Reviews',
        'savings': 'Savings Accounts',
        'search': 'Search',
        'settings': 'Settings',
        'serious-illness': 'Serious Illness Cover',
        'market-analysis': 'The bonkers.ie Report',
        'thank-you': 'Thank you',
        'team': 'Team',
        'unsubscribe': 'Unsubscribe',
        'your-results': 'Your Results',
        'terms': 'Terms & Conditions',
        'partners': 'Partners',
        'press': 'Press Room'
      },
      'buyNow': 'Buy now',
      'compare': 'Compare',
      'coverAmount': 'Cover Amount {0}',
      'day': '{n} day | {n} days',
      'errors': {
        'addressNotCompleted': 'Please choose a valid address',
        'apiSessionExpired': 'Your search expired, please try again.',
        'articleNotFound': 'Article not found',
        'authorNotFound': 'Author not found',
        'bundleNotFound': 'Bundle not found',
        'cardNotFound': 'Card not found',
        'categoryNotFound': 'Blog category "{0}" not found',
        'currentNotFound': 'Current account not found',
        'dateAfterMax': 'Must be before {0}',
        'dateBeforeMin': 'Must be after {0}',
        'dateFormat': 'Must be in the format dd/mm/yyyy',
        'dateInvalid': 'Not a valid date',
        'guideNotFound': 'Guide not found',
        'guideCategoryNotFound': 'Guide category not found',
        'homeInsuranceSearchNotFound': 'Please complete a search to find suitable home insurance plans',
        'lifeInsuranceSearchNotPresent': 'Please complete a search to find suitable life insurance plans',
        'loanNotFound': 'Loan not found',
        'loanSearchNotPresent': 'Please complete a search to find suitable loans',
        'mediaNotFound': 'Media article not found',
        'mortgageNotFound': 'Mortgage not found',
        'mortgageSearchNotPresent': 'Please complete a search to find a suitable mortgage',
        'mortgageThresholdNotMet': 'Minimum mortgage amount not met, please search again with amount above {threshold}',
        'mortgageProtectionSearchNotPresent': 'Please complete a search to find suitable mortgage protection insurance plans',
        'carInsuranceSearchNotFound': 'Please complete a search to find suitable car insurance plans',
        'planNotFound': 'Plan not found',
        'providerNotFound': 'Provider "{0}" not found',
        'savingNotFound': 'Savings account not found',
        'savingSearchNotPresent': 'Please complete a search to find suitable savings accounts',
        'seriousIllnessSearchNotPresent': 'Please complete a search to find suitable serious illness cover plans',
        'videoCategoryNotFound': 'Video category not found'
      },
      'forms': {
        'dontKnow': `Don't know`,
        'finalQuestions': 'Final questions',
        'marketing': {
          'label': 'Your {provider} marketing preferences',
          'optins': {
            'd2d_opt_in': 'Door to door',
            'email_opt_in': 'Email',
            'landline_opt_in': 'Landline phone',
            'phone_opt_in': 'Mobile phone',
            'post_opt_in': 'Post',
            'sms_opt_in': 'SMS'
          },
          'virginLabel': 'Yes! I would like to recieve updates from Virgin Media (even when I am no longer a Virgin Media customer) about exclusive offers, new launches, competitions and news & events via:'
        },
        'next': 'Next',
        'pleaseSelect': 'Please select',
        'steps': {
          'declaration': 'Declaration',
          'details': 'Quote Details',
          'life1': 'Your details',
          'life2': 'Second applicant details'
        }
      },
      'gb': 'unlimited | {n} GB | {n} GB',
      'illnessAmount': 'Illness Cover Amount {0}',
      'info': {
        'phoneLine': '(01) 256 0500',
        'officeHours': {
          'short': 'MON-FRI 10AM-4:30PM',
          'insurance': 'MON-FRI 9AM-5:30PM'
        }
      },
      'lifePremium': 'Monthly Premium {0}',
      'minute': 'unlimited | {n} minute | {n} minutes',
      'month': 'for {n} month | for {n} months',
      'monthSimple': '{n} month | {n} months',
      'more': 'Learn more',
      'nextStep': 'Next step',
      'learnMore': 'Learn More',
      'navigation': {
        'categories': {
          'banking': {
            'credit': 'Credit Cards',
            'current': 'Current Accounts',
            'getStarted': 'Banking & Finance: Get Started',
            'loans': 'Personal Loans',
            'mortgages': 'Mortgages',
            'prepay': 'Prepaid Credit Cards',
            'savings': 'Savings Accounts',
            'title': 'Banking'
          },
          'broadband': {
            'compare': 'Broadband',
            'getStarted': 'Broadband: Get Started',
            'title': 'Broadband'
          },
          'mortgages': {
            'compare': 'Mortgages',
            'getStarted': 'Mortgages: Get Started',
            'firstTimeBuyer': 'First Time Buyer',
            'movingHome': 'Moving Home',
            'switchingMortgage': 'Switching Mortgage',
            'title': 'Mortgages'
          },
          'energy': {
            'business': 'Business Gas & Electricity',
            'dual': 'Gas & Electricity',
            'electricity': 'Electricity',
            'gas': 'Gas',
            'getStarted': 'Gas & Electricity: Get Started',
            'providers': 'Providers',
            'title': 'Gas & Electricity'
          },
          'insurance': {
            'getStarted': 'Insurance: Get Started',
            'health': 'Health Insurance',
            'hi': 'Home Insurance',
            'li': 'Life Insurance',
            'mi': 'Car Insurance',
            'mp': 'Mortgage Protection Insurance',
            'si': 'Serious Illness Cover',
            'ip': 'Income Protection Insurance',
            'title': 'Insurance'
        },
          'newsroom': {
            'ads': 'Ads',
            'getStarted': 'Newsroom: Get started',
            'blog': 'Latest News',
            'guides': 'Guides',
            'media': 'In the Media',
            'podcasts': 'Podcasts',
            'priceChanges': 'Price Changes',
            'marketAnalysis': 'Market Analysis',
            'title': 'Newsroom'
          }
        }
      },
      'ok': 'OK',
      'other': 'Other',
      'pageInfo': {
        'account': {
          'hi-user': 'Hi {fname}',
          'household': {
            'title': 'Household'
          },
          'orders': {
            'title': 'Orders'
          },
          'profile': {
            'title': 'Profile',
            'description': 'Your account details'
          },
          'settings': {
            'title': 'Settings'
          },
          'your-order': 'Your order'
        },
        'ads': {
          'jumbotron': {
            'subtitle': 'Ireland’s leading comparison and switching website'
          },
          'title': 'bonkers.ie ads',
          'description': 'Our mission is to help customers take advantage of the best prices & services on offer from Irish suppliers.'
        },
        'blog': {
          'authors': {
            'description': 'Read about the bonkers.ie content team of subject-matter experts',
            'title': 'Meet the authors'
          },
          'banking': {
            'description': 'Catch up on the latest news and updates from the world of banking',
            'title': 'Banking articles'
          },
          'broadband-phone': {
            'description': 'Read about the latest news and deals in the broadband, phone and TV market',
            'title': 'Broadband, phone, & TV articles'
          },
          'broadband-phone-tv': {
            'description': 'Read about the latest news and deals in the broadband, phone and TV market',
            'title': 'Broadband, phone, & TV articles'
          },
          'gas-electricity': {
            'description': 'Read about the latest news, price movements and deals in the world of energy',
            'title': 'Gas & electricity articles'
          },
          'health-insurance': {
            'description': 'Catch up on the latest news and updates in the insurance sector',
            'title': 'Health insurance articles'
          },
          'insurance': {
            'description': 'Catch up on the latest news and updates in the insurance sector',
            'title': 'Insurance articles'
          },
          'jumbotron': {
            'title': 'Read about the latest deals, news, and savings tips'
          },
          'mortgage': {
            'description': 'Read about the latest news, updates and rate changes in the mortgage market',
            'title': 'Mortgages articles'
          },
          'mortgages': {
            'description': 'Read about the latest news, updates and rate changes in the mortgage market',
            'title': 'Mortgages articles'
          },
          'personal-finance': {
            'description': 'Read about the latest news and information from the world of personal finance',
            'title': 'Personal finance articles'
          },
          'title': 'Price Comparison & Personal Finance Articles',
          'description': 'Read our blog and make informed decisions that will save you money. Compare prices, choose the best service for your requirements and sign up in 3 simple steps.'
        },
        'compare-car-insurance': {
          'confirm-search': {
            'jumbotron': {
              'subtitle': 'Enter your quote reference code and date of birth to pick up where you left off',
              'title': 'Retrieve your car insurance quote'
            },
            'title': 'Car Insurance Policies - Your Results'
          },
          'description': 'Cut the cost of your annual car insurance with a discounted quote. Get the best value cover and buy your policy online on bonkers.ie in just a few minutes.',
          'title': 'Get Car Insurance in Ireland',
          'jumbotron': {
            'title': 'Get your Car Insurance with bonkers.ie',
            'subtitle': 'Buy with us to get an extra 10% discount',
            'listClass': 'alternative-jumbo'
          },
          'provider': {
            'jumbotron': {
              'title': '{providerName} | Car Insurance Providers'
            },
            'title': '{providerName} | Car Insurance Providers'
          },
          'providers': {
            'jumbotron': {
              'subtitle': 'Car insurance providers available on bonkers.ie',
              'title': 'Car Insurance Providers'
            },
            'title': 'Car Insurance Providers'
          },
          'about-you': {
            'description': 'Please provide us with some basic information about you, such as your contact details and employment status, to receive a tailored car insurance quote.',
            'title': 'Get Car Insurance - About You'
          },
          'additional-drivers': {
            'description': 'Please let us know if you would like to add an additional driver to your insurance policy. Up to four additional drivers can be added.',
            'title': 'Get Car Insurance - Additional Drivers'
          },
          'declarations': {
            'description': 'Please answer some final questions, such as the policy start date, and review the declarations to receive your tailored car insurance quote.',
            'title': 'Get Car Insurance - Final Questions'
          },
          'driving-experience': {
            'description': 'Please provide us with some basic information about your driving experience, such as the type of licence you have, to receive a tailored car insurance quote.',
            'title': 'Get Car Insurance - Your Driving Experience'
          },
          'your-car': {
            'description': 'Please provide us with some basic information about your car, such as the registration number and the value, to receive a tailored car insurance quote.',
            'title': 'Get Car Insurance - Your Car'
          },
          'your-results': {
            'jumbotron': {
              'subtitle': 'Filter your results and buy your cover online now',
              'title': 'Get cover in just a few clicks'
            },
            'title': 'Car Insurance Policies - Your Results'
          },
          'apply': {
            'provider-questions': {
              'description': 'To proceed with your application for your chosen car insurance premium please answer some additional provider-specific questions.',
              'title': 'Get Car Insurance - Provider Questions'
            },
            'optional-addons': {
              'description': 'To proceed with your car insurance application please select whether or not you’d like to include any optional add-ons to your premium.',
              'title': 'Get Car Insurance - Optional Add-ons'
            }
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks, {name} - that’s all we need for now!'
            },
            'title': 'Car Insurance - thank you',
            'description': 'Get your car insurance'
          }
        },
        'compare-gas-electricity-prices': {
          'title': 'Switch Gas & Electricity Suppliers',
          'description': 'Get the cheapest energy deal on the market and save money. Easily compare gas and electricity suppliers nationwide and switch today to start saving.',
          'jumbotron': {
            'title': 'Switch Gas & Electricity with bonkers.ie',
            'subtitle': 'Find the cheapest energy deal and save on average',
            'listClass': 'alternative-jumbo'
          }
        },
        'compare-home-insurance': {
          'about-you': {
            'description': 'Protect your home and possessions against the unexpected. Start saving on your home insurance today in just a few simple clicks on bonkers.ie',
            'title': 'Get home insurance in Ireland - About you'
          },
          'confirm-search': {
            'jumbotron': {
              'subtitle': 'Enter your quote reference code and date of birth to pick up where you left off',
              'title': 'Retrieve your home insurance quote'
            }
          },
          'description': 'Buy home insurance cover online in less than 15 minutes. Protect your home and contents against the unexpected while saving on your premium on bonkers.ie.',
          'title': 'Get Home Insurance in Ireland',
          'jumbotron': {
            'title': 'Get your Home Insurance with bonkers.ie',
            'subtitle': 'Get cover in less than 15 minutes',
            'listClass': 'alternative-jumbo',
            'img': {
              'class': 'alternative-jumbo',
              'alt': 'house silhouette',
              'url': 'home-insurance-jumbo.png'
            }
          },
          'declarations': {
            'jumbotron': {
              'subtitle': 'Specify any valuable items below, complete the declarations and your quotes will be on the next page!',
              'title': 'Nearly there - just a few more details needed'
            },
            'description': 'Protect your home and possessions against the unexpected. Start saving on your home insurance today in just a few simple clicks on bonkers.ie',
            'title': 'Get home insurance in Ireland - Declarationse'
          },
          'provider': {
            'jumbotron': {
              'title': '{providerName} | Home Insurance Providers'
            },
            'title': '{providerName} | Home Insurance Providers'
          },
          'providers': {
            'jumbotron': {
              'subtitle': 'Get a discounted quote for your home insurance',
              'title': 'Home Insurance Providers in Ireland'
            },
            'description': 'Get a discounted quote for your home insurance from Zurich. Switch providers to get the best deal on your home insurance and protect your home and possessions.',
            'title': 'Home Insurance Providers in Ireland'
          },
          'your-home': {
            'description': 'Tell us about your home. Protect your home and possessions against the unexpected. Start saving on your home insurance today in just a few simple clicks on bonkers.ie',
            'title': 'Get home insurance in Ireland - Your home'
          },
          'your-results': {
            'jumbotron': {
              'subtitle': 'Filter your results and place your order for cover online now',
              'title': 'Select the policy that best suits your needs'
            },
            'description': 'Your home insurance quote results. Choose the policy that best matches your requirements - you can pay upfront or monthly, whichever you prefer',
            'title': 'Home Insurance Policies - Your Results'
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks, {name} - that’s all we need for now!'
            },
            'title': 'Home Insurance - thank you',
            'description': 'Get your home insurance'
          }
        },
        'compare-insurance': {
          'description': 'Easily compare insurance quotes and benefits on bonkers.ie. Review policies across a range of insurance types from Ireland’s main providers and switch today.',
          'jumbotron': {
            'listClass': 'alternative-jumbo',
            'title': 'Get Insurance cover with bonkers.ie ',
            'subtitle': 'Apply online and get cover in under an hour'
          },
          'title': 'Compare Insurance Policies in Ireland'
        },
        'compare-loans': {
          'title': 'Compare Personal Loans in Ireland',
          'description': 'Easily compare loan interest rates and monthly repayments. Review loan options from Ireland\'s main lenders and see what your monthly repayments would be.',
          'jumbotron': {
            'subtitle': 'Compare rates, features and monthly repayments',
            'listClass': 'alternative-jumbo',
            'title': 'Find the best Personal Loan interest rate',
            'warning': 'Fraud alert: bonkers.ie will never call you or contact you by email about a personal loan application'
          },
          'lender': {
            'title': '{providerName} | Personal Loans Lenders',
            'description': `Find out about all {providerName} Personal Loans interest rates and repayments. Compare loan interest rates and monthly repayments with bonkers.ie.`
          },
          'lenders': {
            'jumbotron': {
              'subtitle': 'Compare personal loans from top financial institutions'
            },
            'title': 'Personal Loan lenders in Ireland',
            'description': 'Compare personal loans from top financial institutions. Review interest rates from loan providers in Ireland and see what your repayments would be.'
          },
          'rate-changes': {
            'jumbotron': {
              'subtitle': 'Review all changes to personal loan rates in Ireland'
            },
            'title': 'Personal Loan Rate Changes in Ireland',
            'description': 'Review all changes to personal loan rates in Ireland. Compare interest rates and monthly repayments from lenders nationwide with our loan comparison service.'
          },
          'show': {
            'description': `Don't Overpay for Your Loan. Get the Best Interest Rates and Lowest Repayments for Your Personal Loan with bonkers.ie! Try our FREE Comparison Tool`,
            'jumbotronList': {
              'principal': '{principal} personal loan',
              'term': '{term} month term',
              'monthly': '{monthly} per month'
            }
          },
          'your-results': {
            'title': 'Personal Loans - Your Results',
            'description': `Don't Overpay for Your Loan. Get the Best Interest Rates and Lowest Repayments for Your Personal Loan with bonkers.ie! Try our FREE Comparison Tool`,
            'jumbotron': {
              'subtitle': 'Compare interest rates and monthly repayments. Find the loan that’s right for you.',
              'warning': 'Fraud alert: bonkers.ie will never call you or contact you by email about a personal loan application.'
            }
          }
        },
        'compare-life-insurance': {
          'title': 'Get Life Insurance in Ireland | bonkers.ie',
          'description': 'Get life insurance cover on bonkers.ie in under an hour. Review the different policies, quotes and benefits offered from Ireland’s main life insurance providers.',
          'jumbotron': {
            'title': 'Get your Life Insurance with bonkers.ie',
            'subtitle': 'Make your enquiry now and our qualified advisors will get in contact with you',
            'img': {
              'alt': 'bonkers.ie Compare Life Insurance',
              'class': 'alternative-jumbo',
              'url': 'lifeinsurance-jumbo.png'
            },
            'listClass': 'alternative-jumbo'
          },
          'apply': {
            'jumbotron': {
              'subtitle': 'Make your enquiry now. Our qualified advisor will phone you to confirm your medical history and answer any questions you may have. The call will last approximately 10 minutes',
              'title': 'Great choice! Just a few details needed.'
            },
            'title': 'Life Insurance - Your application',
            'description': 'Get your life insurance in less than 1 hour!'
          },
          'declaration': {
            'jumbotron': {
              'title': 'Final step!'
            },
            'title': 'Life Insurance - Your application'
          },
          'provider': {
            'title': '{providerName} | Life Insurance Providers',
            'description': 'Get your life insurance in less than 1 hour!'
          },
          'providers': {
            'jumbotron': {
              'subtitle': 'Compare life insurance policies from all Irish providers'
            },
            'title': 'Life Insurance Providers in Ireland',
            'description': 'Compare life insurance policies from all Irish providers. Review quotes and benefits from Ireland’s main life insurance providers and find the best value cover.'
          },
          'search': {
            'title': 'Life Insurance - Your Requirements',
            'description': 'Provide your details to start your life insurance comparison. Filter your results and request a callback to discuss the options available to you.'
          },
          'second-life': {
            'jumbotron': {
              'title': 'Nearly there! Now about the second life insured'
            },
            'title': 'Life Insurance Insurance - Your application',
            'description': 'Get your life insurance in less than 1 hour!'
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks, {name} - that’s all we need for now!'
            },
            'title': 'Life Insurance - Thank you',
            'description': 'Get your life insurance in less than 1 hour!'
          },
          'thank-you-lead': {
            'title': 'Life Insurance - Thank you',
            'description': 'Expect a callback from our life insurance team soon. You can discuss the different life insurance policies on the market with one of our experts.'
          },
          'your-results': {
            'jumbotron': {
              'title': 'Select the quote that best suits your needs',
              'subtitle': 'Our team of qualified insurance advisors will guide you through the process. You could even have cover in under 1 hour!'
            },
            'title': 'Life Insurance Policies - Your Results',
            'description': 'Get your life insurance in less than 1 hour!'
          }
        },
        'compare-mortgage-protection-insurance': {
          'title': 'Get mortgage protection in Ireland | bonkers.ie',
          'description': 'Purchase mortgage protection insurance in less than 1 hour! Choose the best value premium and cover available from Ireland’s main insurance providers on bonkers.ie.',
          'jumbotron': {
            'title': 'Get your Mortgage Protection with bonkers.ie',
            'subtitle': 'Make your enquiry now and our qualified advisors will get in contact with you',
            'img': {
              'alt': 'bonkers.ie Compare Life Insurance',
              'class': 'alternative-jumbo',
              'url': 'lifeinsurance-jumbo.png'
            },
            'listClass': 'alternative-jumbo'
          },
          'apply': {
            'jumbotron': {
              'subtitle': 'Make your enquiry now. Our qualified advisor will phone you to confirm your medical history and answer any questions you may have. The call will last approximately 10 minutes',
              'title': 'Great choice! Just a few details needed.'
            },
            'title': 'Mortgage Protection Insurance - Your application',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'declaration': {
            'jumbotron': {
              'title': 'Final step!'
            },
            'title': 'Mortgage Protection Insurance - Your application',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'provider': {
            'jumbotron': {
              'title': '{providerName} | Mortgage Protection Providers'
            },
            'title': '{providerName} | Mortgage Protection Providers',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'providers': {
            'jumbotron': {
              'subtitle': 'Compare mortgage protection policies from Irish providers',
              'title': 'Mortgage Protection Providers in Ireland'
            },
            'title': 'Mortgage Protection Providers in Ireland',
            'description': 'Compare mortgage protection policies from Irish providers. Review quotes and benefits from the main life insurance providers and find the best value cover.'
          },
          'second-life': {
            'jumbotron': {
              'title': 'Nearly there! Now about the second life insured'
            },
            'title': 'Mortgage Protection Insurance - Your application',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'search': {
            'title': 'Mortgage Protection Insurance - Your Search',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks, {name} - that’s all we need for now!'
            },
            'title': 'Mortgage Protection Insurance - thank you',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover.'
          },
          'your-results': {
            'jumbotron': {
              'title': 'Your personal quotes are below - which one will you pick?',
              'subtitle': 'Pick the one that you think best matches your requirements. Don\'t worry if you are unsure, our adviser will contact you to guide you and answer any questions. You could have your policy in under 1 hour!'
            },
            'title': 'Mortgage Protection Insurance Policies - Your Results',
            'description': 'Get mortgage protection insurance in less than 1 hour! Easily compare premiums from Ireland’s main insurance providers and find the best value cover. '
          }
        },
        'compare-savings-accounts': {
          'title': 'Compare Savings Accounts in Ireland',
          'description': 'Quickly and easily find the best return for your savings. Compare interest rates and account features using our savings account comparison service.',
          'jumbotron': {
            'title': 'Find the best return for your Savings',
            'listClass': 'alternative-jumbo',
            'subtitle': 'Easily compare interest rates and account features'
          },
          'provider': {
            'title': '{providerName} | Savings Accounts',
            'description': 'Find out about all {providerName} Savings Accounts. Compare interest rates and account features with bonkers.ie. Get the best return for your savings.'
          },
          'providers': {
            'title': 'Savings Account Providers in Ireland',
            'description': 'Compare savings accounts from top financial institutions. Review interest rates and account features to find the best savings account to suit your needs.',
            'jumbotron': {
              'subtitle': 'Compare savings accounts from top financial institutions'
            }
          },
          'rate-changes': {
            'jumbotron': {
              'subtitle': 'Review all changes to savings account rates in Ireland'
            },
            'title': 'Savings Account Rate Changes in Ireland',
            'description': 'Review all changes to savings account rates in Ireland. Compare interest rates and account features to find the best return for your savings on bonkers.ie'
          },
          'search': {
            'title': ' Savings Accounts - Your Search',
            'description': 'Provide your details to start your savings account comparison. Compare your results and find the best savings account for you.'
          },
          'show': {
            'description': 'Stay up to date on the Latest Savings Rates Changes from all of the Major Financial institutions. Get the Best Savings Accounts with the BEST INTEREST RATES through bonkers.ie!',
            'jumbotronList': {
              'child': 'Child saver',
              'dirtExempt': 'DIRT exempt',
              'lump': 'Lump sum saver',
              'rate': {
                'fix': '{rate} AER (fixed)',
                'var': '{rate} AER (variable)'
              },
              'reg': 'Regular Monthly saver',
              'term': 'Term deposit'
            }
          },
          'your-results': {
            'jumbotron': {
              'subtitle': 'Compare interest rates and account features. Get the best return for your savings.'
            },
            'title': 'Savings Accounts - Your Results',
            'description': 'Stay up to date on the Latest Savings Rates Changes from all of the Major Financial institutions. Get the Best Savings Accounts with the BEST INTEREST RATES through bonkers.ie!'
          }
        },
        'compare-serious-illness-cover': {
          'apply': {
            'jumbotron': {
              'subtitle': 'Make your enquiry now. Our qualified advisor will phone you to confirm your medical history and answer any questions you may have. The call will last approximately 10 minutes',
              'title': 'Great choice! Just a few details needed.'
            },
            'title': 'Serious illness'
          },
          'declaration': {
            'title': 'Final step!'
          },
          'description': 'Compare quotes and find the best serious illness cover. Our comparison service lets you review policies and benefits from Ireland\'s main insurers.',
          'title': 'Compare Serious Illness Cover in Ireland',
          'jumbotron': {
            'title': 'Get your Serious Illness Cover with bonkers.ie',
            'subtitle': 'Make your enquiry now and our qualified advisors will get in contact with you',
            'img': {
              'alt': 'bonkers.ie Compare Life Insurance',
              'class': 'alternative-jumbo',
              'url': 'lifeinsurance-jumbo.png'
            },
            'listClass': 'alternative-jumbo'
          },
          'provider': {
            'title': '{providerName} | Serious Illness Providers'
          },
          'providers': {
            'description': 'Compare serious illness policies from all Irish providers. Review quotes and benefits from Ireland’s main life insurance providers and find the best policy.',
            'jumbotron': {
              'subtitle': 'Compare serious illness policies from all Irish providers'
            },
            'title': 'Serious Illness Providers in Ireland'
          },
          'second-life': {
            'jumbotron': {
              'title': 'Nearly there! Now about the second life insured'
            },
            'title': 'Serious Illness'
          },
          'search': {
            'title': 'Serious Illness Insurance - Your Search',
            'description': 'Compare quotes and find the best serious illness cover. Our comparison service lets you review policies and benefits from Ireland\'s main insurers.'
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks {name} -  that’s all we need for now!'
            },
            'title': 'What happens next?'
          },
          'your-results': {
            'jumbotron': {
              'title': 'Your personal quotes are below - which one will you pick?',
              'subtitle': 'Pick the one that you think best matches your requirements. Don\'t worry if you are unsure, our adviser will contact you to guide you and answer any questions. You could have your policy in under 1 hour!'
            },
            'title': 'Serious Illness Cover Policies - Your Results'
          }
        },
        'compare-income-protection-insurance': {
          'apply': {
            'jumbotron': {
              'subtitle': 'Make your enquiry now. Our qualified advisor will phone you to confirm your medical history and answer any questions you may have. The call will last approximately 10 minutes',
              'title': 'Great choice! Just a few details needed.'
            },
            'title': 'Income Protection'
          },
          'declaration': {
            'title': 'Final step!'
          },
          'description': 'Compare quotes and find the best income protection insurance. Our comparison service lets you review policies and benefits from Ireland\'s main insurers.',
          'title': 'Compare Income Protection Insurance in Ireland',
          'jumbotron': {
            'title': 'Get your Income Protection Insurance with bonkers.ie',
            'subtitle': 'Make your enquiry now and our qualified advisors will get in contact with you',
            'img': {
              'alt': 'bonkers.ie Compare Income Protection',
              'class': 'alternative-jumbo',
              'url': 'lifeinsurance-jumbo.png'
            },
            'listClass': 'alternative-jumbo'
          },
          'provider': {
            'title': '{providerName} | Income Protection Providers'
          },
          'providers': {
            'description': 'Compare income protection policies from all Irish providers. Review quotes and benefits from Ireland’s main life insurance providers and find the best policy.',
            'jumbotron': {
              'subtitle': 'Compare income protection policies from all Irish providers'
            },
            'title': 'Income Protection Providers in Ireland'
          },
          'second-life': {
            'jumbotron': {
              'title': 'Nearly there! Now about the second life insured'
            },
            'title': 'Income Protection'
          },
          'search': {
            'title': 'Income Protection Insurance - Your Search',
            'description': 'Compare quotes and find the best income protection cover. Our comparison service lets you review policies and benefits from Ireland\'s main insurers.'
          },
          'thank-you': {
            'jumbotron': {
              'title': 'Thanks {name} -  that’s all we need for now!'
            },
            'title': 'What happens next?'
          },
          'your-results': {
            'jumbotron': {
              'title': 'Your personal quotes are below - which one will you pick?',
              'subtitle': 'Pick the one that you think best matches your requirements. Don\'t worry if you are unsure, our adviser will contact you to guide you and answer any questions. You could have your policy in under 1 hour!'
            },
            'title': 'Income Protection Policies - Your Results'
          }
        },
        'compare-tv-broadband-phone': {
          'apply': {
            'jumbotron': {
              'title': 'Great choice! Just a few details needed',
              'subtitle': 'Any questions? Call our dedicated team on {phone}'
            },
            'title': '{bundleName}'
          },
          'jumbotron': {
            'img': {
              'class': 'alternative-jumbo',
              'alt': 'broadband user',
              'url': 'broadband-jumbo.png'
            },
            'listClass': 'alternative-jumbo',
            'title': 'Switch Broadband with bonkers.ie',
            'subtitle': 'Get the best broadband, phone and TV deals from'
          },
          'price-changes': {
            'jumbotron': {
              'subtitle': 'Review changes to broadband bundles from Irish providers'
            },
            'title': 'Broadband price changes'
          },
          'provider': {
            'title': '{providerName} | Broadband Providers'
          },
          'providers': {
            'jumbotron': {
              'subtitle': 'Compare broadband providers and find the best bundle'
            },
            'title': 'Broadband Providers in Ireland',
            'description': 'Compare broadband, phone and TV packages and prices from all of Ireland’s main providers on bonkers.ie'
          },
          'show': {
            'title': '{bundleName}'
          },
          'thank-you': {
            'jumbotron': {
              'subtitle': 'Any questions? Call our dedicated team on {phone}',
              'title': 'That’s it, {name}'
            },
            'title': 'Your order for {provider} {bundle}',
            'description': 'Your Broadband order has been placed'
          },
          'description': 'Switch to a better value broadband deal on bonkers.ie. Choose from the deals available in your area from Ireland’s main providers and place an order online.',
          'title': 'Get the Best Broadband, Phone, TV, and Mobile Deals',
          'your-results': {
            'jumbotron': {
              'subtitle': 'Select the deal with the best speed and price for you, then place your order online',
              'title': 'Here are the best broadband deals available in your area'
            },
            'title': 'Compare Broadband, Phone & TV Deals - Best Speed & Prices',
            'description': 'Your Broadband, TV and Phone results. Choose the plan that best matches your requirements'
          }
        },
        'guides': {
          'category': {
            'jumbotron': {
              'subtitle': '{subtitle}',
              'title': '{description} Guides'
            },
            'title': '{description} Guides'
          },
          'jumbotron': {
            'title': 'Looking for some help?'
          },
          'title': 'Help & Guides',
          'description': 'bonkers.ie help centre, search faqs for answers, ask the community your question on boards and keep up to date on the latest news'
        },
        'home-movers': {
          'compare-mortgages': {
            'jumbotron': {
              'title': 'Moving Home? Sort out all your mortgage needs'
            },
            'title': 'Moving Home? Sort out all your mortgage needs here'
          }
        },
        'compare-health-insurance': {
          'title': 'Compare Health Insurance in Ireland',
          'description': 'Compare Health Insurance in Ireland. Receive tailored recommendations from an expert for just €150.',
          'jumbotron': {
            'img': {
              'class': 'alternative-jumbo',
              'alt': 'broadband user',
              'url': 'broadband-jumbo.png'
            },
            'listClass': 'alternative-jumbo',
            'title': 'Compare Health Insurance in Ireland',
            'subtitle': 'Receive tailored recommendations from an expert for just €150'
          },
        'list': [
              'Book a consultation with an expert health insurance advisor.',
              'Receive tailored recommendations for just €150.'
            ],
         'apply': {
            'title': 'Compare Health Insurance in Ireland'
         },
         'thank-you': {
          'title': 'Compare Health Insurance in Ireland'
       }
        },
        'media': {
          'title': 'In the media',
          'description': 'Media contacts and press information for Irish comparison site bonkers.ie'
        },
        'newsroom': {
          'jumbotron': {
            'img': {
              'alt': 'bonkers.ie Newsroom',
              'class': 'alternative-jumbo',
              'url': 'news-room.png'
            },
            'listClass': 'alternative-jumbo',
            'subtitle': 'Stay informed by signing up to our monthly newsletter.'
          },
          'title': 'The latest news, guides, and radio interviews at your fingertips ',
          'description': 'The latest news, guides, and radio interviews at your fingertips. Stay informed by signing up to our monthly newsletter.'
        },
        'podcasts': {
          'jumbotron': {
            'subtitle': 'Grab a cuppa and have a listen. News, analysis, debate and tips on how to save you money!',
            'title': 'The bonkers.ie podcast'
          },
          'title': 'Podcasts',
          'description': 'The bonkers.ie podcast. Grab a cuppa and have a listen. News, analysis, debate and tips on how to save you money!'
        }
      },
      'proceed': 'Proceed',
      'products': {
        'car-insurance': {
          'compare': 'Car Insurance',
          'button': 'Lower your premium today',
          'menu': {
            'sub': 'Get on the road to cheaper car insurance'
          },
          'name': 'car insurance'
        },
        'cards': {
          'compare': 'Credit Cards',
          'menu': {
            'cta': 'Find the lowest interest rate',
            'sub': 'Compare credit cards and find the lowest interest rate.'
          },
          'name': 'credit card | credit cards'
        },
        'currents': {
          'compare': 'Current Accounts',
          'fees': {
            'detail': {
              'free': {
                'balance': 'Fee-free banking if you maintain {balance} at all times',
                'balance-lodgement': 'Fee-free banking if you lodge {lodgement} every month and maintain {balance} at all times',
                'monthly': 'Fee-free banking if you lodge {lodgement} every month'
              },
              'reduced': {
                'balance': 'Fee-free banking is not available, however you will be charged reduced fees if you maintain {balance} at all times',
                'balance-lodgement': 'Fee-free banking is not available, but you will be charged reduced fees if you lodge {lodgement} every month and maintain {balance} at all times',
                'lodgement': 'Fee-free banking is not available, but you will be charged reduced fees if you lodge {lodgement} every month'
              }
            },
            'free': 'Fee-free banking',
            'monthly': 'A monthly fee of {0} applies',
            'quarterly': 'A quarterly fee of {0} applies'
          },
          'menu': {
            'cta': 'Reduce my banking fees',
            'sub': 'Compare current account fees and find the best account for you.'
          },
          'name': 'current account | current accounts'
        },
        'dualfuel': {
          'compare': 'Gas & Electricty',
          'button': 'Get cheaper energy bills',
          'link': 'dual-fuel',
          'menu': {
            'cta': 'Get cheaper gas & electricity',
            'sub': 'Compare gas & electricity prices and switch online in minutes for lower bills.'
          }
        },
        'electricity': {
          'compare': 'Electricity only',
          'button': 'Get cheaper electricity',
          'link': 'electricity',
          'menu': {
            'cta': 'Get cheaper electricity',
            'sub': 'Compare the best electricity prices from all suppliers in Ireland.'
          }
        },
        'gas': {
          'compare': 'Gas only',
          'button': 'Get cheaper gas',
          'link': 'gas',
          'menu': {
            'cta': 'Get cheaper gas',
            'sub': 'Compare the best natural gas prices from all suppliers in Ireland and save big on your bills.'
          }
        },
        'home-insurance': {
          'compare': 'Home Insurance',
          'button': 'Protect your home and contents',
          'menu': {
            'sub': 'Protect your home and possessions against the unexpected.'
          },
          'name': 'home insurance'
        },
        'life-insurance': {
          'compare': 'Life Insurance',
          'button': 'Get peace of mind',
          'menu': {
            'sub': 'Easily compare life assurance quotes across a range of providers.'
          },
          'name': 'life insurance'
        },
        'loans': {
          'compare': 'Personal Loans',
          'menu': {
            'cta': 'Lower my loan repayments',
            'sub': 'Compare monthly repayments on loans and find the best rate.'
          },
          'name': 'personal loan | personal loans'
        },
        'market-analysis': {
          'title': 'Market Analysis',
          'description': 'Lorem Ipsum.',
          'jumbotron': {
            'subtitle': 'bonkers.ie Bi-Annual Market Analysis'
          }
        },
        'mortgage-protection': {
          'compare': 'Mortgage Protection',
          'button': 'Find the lowest rates',
          'name': 'mortgage protection',
          'menu': {
            'sub': 'Find the best value mortgage protection cover in just seconds.'
          }
        },
        'income-protection': {
          'compare': 'Compare Income Protection',
          'button': 'Find the lowest rates',
          'name': 'income protection',
          'menu': {
            'sub': 'Find the best value income protection cover in just seconds.'
          }
        },
        'mortgages': {
          'compare': 'Mortgages',
          'menu': {
            'cta': 'Find the lowest mortgage rate',
            'sub': 'Find the best mortgage rate on the market in minutes.'
          },
          'name': 'mortgage | mortgages'
        },
        'prepay-cards': {
          'compare': 'Prepaid Credit Cards',
          'menu': {
            'cta': 'Find the best value card',
            'sub': 'Compare fees and charges and find the best card for you.'
          },
          'name': 'prepaid credit card | prepaid credit cards'
        },
        'savings': {
          'compare': 'Savings Accounts',
          'menu': {
            'cta': 'Get a better return',
            'sub': 'Find the best return for your money in just seconds.'
          },
          'name': 'savings account | savings accounts'
        },
        'health-insurance': {
          'compare': 'Health Insurance',
          'button': 'Book a consultation',
          'name': 'Health insurance'
        },
        'serious-illness': {
          'compare': 'Serious Illness',
          'button': 'Compare policies',
          'menu': {
            'sub': 'Compare policies across a range of providers and get a new quote in just seconds.'
          },
          'name': 'Serious illness cover'
        }
      },
      'provider': 'Provider',
      'result': 'No results | {n} result | {n} results',
      'seeDetail': 'See details',
      'showResults': 'Show {n} result | Show {n} results',
      'term': 'Term {0} Years',
      'year': '{n} year | {n} years',
      'yesNo': {
        'false': 'No',
        'true': 'Yes'
      }
    });
  });
};
